<template>
  <div class="editorx_body" v-html="htmlContent"></div>
</template>
<script>
export default {
  data() {
    return {
      htmlContent: null,
    };
  },
  props: {
    data: null,
  },
  methods: {
    convertEditorJSToHTML(data) {
      let html = "";
      if (data.is_legacy) {
        return data.blocks;
      }
      data.blocks.forEach((block) => {
        switch (block.type) {
          case "header":
            html += `<h${block.data.level} id="${block.id}" >${block.data.text}</h${block.data.level}>`;
            break;
          case "paragraph":
            html += `<p>${block.data.text}</p>`;
            break;
          case "image":
            html += `<img src="${block.data.file.url}" width="825" height="500" alt="${block.data.caption}" />`;
            break;
          case "list":
            if (block.data.style === "ordered") {
              html += "<ol>";
              block.data.items.forEach((item) => {
                html += `<li>${item}</li>`;
              });
              html += "</ol>";
            } else if (block.data.style === "unordered") {
              html += "<ul>";
              block.data.items.forEach((item) => {
                html += `<li>${item}</li>`;
              });
              html += "</ul>";
            }
            break;
          case "table":
            html += "<table>";
            if (block.data.content && block.data.content.length > 0) {
              html += "<thead>";
              html += "<tr>";
              block.data.content[0].forEach((header) => {
                html += `<th>${header}</th>`;
              });
              html += "</tr>";
              html += "</thead>";
              html += "<tbody>";
              for (let i = 1; i < block.data.content.length; i++) {
                html += "<tr>";
                block.data.content[i].forEach((cell) => {
                  html += `<td>${cell}</td>`;
                });
                html += "</tr>";
              }
              html += "</tbody>";
            }
            html += "</table>";
            break;

          case "quote":
            html += '<div class="d-flex-row justify-start gap-10 quote-text">';
            html += '<div class="quote"></div>';
            html +=
              '<p class="t-white font-family-1 title-h5 f-w-600 quote-text-text">' +
              block.data.text +
              "</p>";
            html += "</div>";
            break;
          case "warning":
            html += '<div class="d-flex-row justify-start gap-10 warning">';
            html +=
              '<p class="t-white font-family-1 title-h5 f-w-600" >' +
              block.data.message +
              "</p>";
            html += "</div>";
            break;
          case "code":
            html +=
              '<p class="font-family-1 title-h5 f-w-600 code" >' +
              block.data.code +
              "</p>";
            break;
          default:
            break;
        }
      });
      return html;
    },
  },
  beforeMount() {
    this.htmlContent = this.convertEditorJSToHTML(this.data);
  },
};
</script>
